module.exports = __webpack_public_path__ + "img/badge_color_spe-middle.9d56fdc6.svg";